import { render } from "./ButtonSmile.vue?vue&type=template&id=5b5e65d2&scoped=true"
import script from "./ButtonSmile.vue?vue&type=script&lang=js"
export * from "./ButtonSmile.vue?vue&type=script&lang=js"

import "./ButtonSmile.vue?vue&type=style&index=0&id=5b5e65d2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5e65d2"]])

export default __exports__